import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspaceExplainConversationCountParams {
  days_ago: number;
  include_previous_period?: boolean;
  include_top_workspace_check?: boolean;
}

export interface IFetchWorkspaceExplainConversationCountResponse {
  explain_count: string;
  previous_period_explain_count: string;
  top_half_of_all_workspaces: boolean;
  top_third_of_all_workspaces: boolean;
}

export function useFetchWorkspaceExplainConversationsCount({
  days_ago,
  include_previous_period = false,
  include_top_workspace_check = false,
}: IFetchWorkspaceExplainConversationCountParams): UseQueryResult<
  IFetchWorkspaceExplainConversationCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspaceExplainConversationCountResponse>(
    [
      "workspace-explain-count",
      {
        days_ago,
        include_previous_period,
        include_top_workspace_check,
      },
    ],
    async (): Promise<IFetchWorkspaceExplainConversationCountResponse> => {
      return await axios
        .get(`/v1/workspaces/explain/count`, {
          params: {
            days_ago,
            include_previous_period,
            include_top_workspace_check,
          },
        })
        .then((r) => {
          return r.data as IFetchWorkspaceExplainConversationCountResponse;
        });
    }
  );

  return query;
}
